<template>
  <div class="table-list page-box">
    <div class="page-content">
      <div class="content-header">
        <vs-button
          v-if="isAuth('sys:data:permission:table:update')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('sys:data:permission:table:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn"
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              类型
            </vs-th>
            <vs-th>
              域名
            </vs-th>
            <vs-th>
              路径前缀
            </vs-th>
            <vs-th>
              AppId
            </vs-th>
            <vs-th>
              EndPoint
            </vs-th>
            <vs-th>
              accessKey
            </vs-th>
            <vs-th>
              accessSecret
            </vs-th>
            <vs-th>
              bucketName
            </vs-th>
            <vs-th>
              区域
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{getType(tr)}}
              </vs-td>
              <vs-td
                style="max-width: 180px;min-width: 120px"
              >
                <span class="rap-normal">{{tr.domain}}</span>
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{tr.prefix}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{tr.qcloudAppId}}
              </vs-td>
              <vs-td>
                {{tr.aliyunEndPoint}}
              </vs-td>
              <vs-td>
                {{tr.accessKey}}
              </vs-td>
              <vs-td>
                {{tr.accessSecret}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{tr.bucketName}}
              </vs-td>
              <vs-td
                style="min-width: 100px"
              >
                <!--区域-->
                {{tr.qcloudRegion || '-'}}
              </vs-td>
              <vs-td
                style="min-width: 80px"
              >
                <span
                  class="self-tag"
                  :style="getstyle(tr)"
                >
                  {{tr.status == 1 ?'启用': '禁用'}}
                </span>
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                <el-button
                  type="text"
                  v-if="isAuth('sys:data:permission:table:update')"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:data:permission:table:delete')"
                  class="delete-btn"
                  @click.native="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-dialog
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editSuccess"
    ></edit-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editDialog from '@/components/sys/ossConfig/editDialog'
import addDialog from "@/components/sys/ossConfig/addDialog";
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { colorRgba } from "@/utils";
import {deleteConfig} from "../../../api/sys/ossConfig/ossConfig";
export default {
  name: "index",
  components: {
    addDialog,
    editDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {
        id: '',
      },
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/oss/config';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc'
      }
      return true;
    },
    getType(tr){
      switch (tr.type){
        case 1:
          return '七牛';
        case 2:
          return '阿里云';
        case 3:
          return '腾讯云';
      }
    },
    getstyle(tr){
      if(tr.status === 1){
        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      setTimeout(() => {
        this.editDialogShow = true;
        this.currentRow = row;
      },200);
    },
    editSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.currentRow = {};
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteConfig(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.table-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
}
</style>
